module.exports = __webpack_public_path__ + "static/media/Quick_poll.5be81805.png";